"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipSource = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = require("./Tooltip");
var _Transition = require("./Transition");
var _excluded = ["children", "showing", "interactive", "sourceRef", "duration", "delay"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TooltipSource = exports.TooltipSource = /*#__PURE__*/function (_Component) {
  _inherits(TooltipSource, _Component);
  function TooltipSource() {
    var _this;
    _classCallCheck(this, TooltipSource);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TooltipSource, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hovered: false,
      triggered: false,
      sourceRef: null
    });
    _defineProperty(_assertThisInitialized(_this), "timer", null);
    _defineProperty(_assertThisInitialized(_this), "animationFrame", null);
    _defineProperty(_assertThisInitialized(_this), "setSourceRef", function (ref) {
      if (!ref) return _this.state.sourceRef;
      _this.setHoverable(ref);
      _this.setState({
        sourceRef: ref
      });
      return ref;
    });
    _defineProperty(_assertThisInitialized(_this), "setHoverable", function (ref) {
      if (ref) {
        var _this$props = _this.props,
          hoverable = _this$props.hoverable,
          clickable = _this$props.clickable;
        _this.clearHoverable(ref);
        if (clickable) {
          ref.onmousedown = _this.onMouseClick;
        }
        if (hoverable) {
          ref.onmouseenter = _this.onMouseOver;
          ref.onmouseleave = _this.onMouseOut;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "clearHoverable", function (ref) {
      if (ref) {
        ref.onmouseenter = null;
        ref.onmouseleave = null;
        ref.onmousedown = null;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseClick", function () {
      return _this.state.hovered ? _this.onMouseOut() : _this.onMouseOver();
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function () {
      var delay = _this.props.delay;
      _this.stopTimer();
      _this.triggered = true;
      var delayValue = Array.isArray(delay) ? delay[0] : delay;
      if (delayValue) {
        _this.timer = setTimeout(function () {
          return _this.triggered && _this.setHovered();
        }, delayValue);
      } else {
        _this.setHovered();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setHovered", function () {
      return _this.setState({
        hovered: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseOut", function () {
      var delay = _this.props.delay;
      _this.stopTimer();
      _this.triggered = false;
      var delayValue = Array.isArray(delay) && delay.length > 1 ? delay[1] : null;
      if (delayValue) {
        _this.timer = setTimeout(_this.unsetHovered, delayValue);
      } else {
        _this.animationFrame = window.requestAnimationFrame(_this.unsetHovered);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "unsetHovered", function () {
      return !_this.triggered && _this.setState({
        hovered: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "stopTimer", function () {
      clearTimeout(_this.timer);
      _this.timer = null;
    });
    _defineProperty(_assertThisInitialized(_this), "setRef", function (ref) {
      return ref && !_this.props.sourceRef && _this.setSourceRef(ref.parentNode);
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      return _this.setSourceRef(_this.props.sourceRef);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.stopTimer();
      _this.clearHoverable(_this.state.sourceRef);
      window.cancelAnimationFrame(_this.animationFrame);
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, _ref) {
      var curSourceRef = _ref.sourceRef;
      var _this$props2 = _this.props,
        sourceRef = _this$props2.sourceRef,
        hoverable = _this$props2.hoverable,
        clickable = _this$props2.clickable;
      var prevSourceRef = prevProps.sourceRef,
        prevHoverable = prevProps.hoverable,
        prevClickable = prevProps.clickable;
      if (sourceRef !== prevSourceRef && sourceRef !== curSourceRef) {
        _this.setSourceRef(sourceRef);
      }
      if (hoverable !== prevHoverable || clickable !== prevClickable) {
        _this.setHoverable(curSourceRef);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props3 = _this.props,
        children = _this$props3.children,
        showing = _this$props3.showing,
        interactive = _this$props3.interactive,
        _ = _this$props3.sourceRef,
        duration = _this$props3.duration,
        delay = _this$props3.delay,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var _this$state = _this.state,
        hovered = _this$state.hovered,
        sourceRef = _this$state.sourceRef,
        triggered = _this$state.triggered;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'tooltip-source',
        ref: _this.setRef,
        onMouseOver: interactive ? _this.onMouseOver : undefined,
        onMouseOut: interactive ? _this.onMouseOut : undefined
      }, /*#__PURE__*/_react["default"].createElement(_Transition.Transition, {
        enter: sourceRef && (showing === undefined ? hovered : showing),
        timeout: duration
      }, function (entering) {
        return /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, _extends({
          sourceRef: sourceRef,
          entering: entering,
          interactive: interactive,
          duration: duration
        }, rest), children);
      }));
    });
    return _this;
  }
  return _createClass(TooltipSource);
}(_react.Component);
_defineProperty(TooltipSource, "propTypes", _objectSpread(_objectSpread({}, _Tooltip.tooltipPropTypes), {}, {
  children: _propTypes["default"].node.isRequired,
  sourceRef: _propTypes["default"].instanceOf(Element),
  duration: _propTypes["default"].number,
  delay: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  theme: _propTypes["default"].string,
  showing: _propTypes["default"].bool,
  hoverable: _propTypes["default"].bool,
  clickable: _propTypes["default"].bool
}));
_defineProperty(TooltipSource, "defaultProps", {
  duration: 300,
  delay: 0,
  hoverable: true,
  clickable: false
});